<template>
  <div class="content">
    <div class="main nav">
      <img class="logo" @click="goHome" src="@/assets/pc/logo.png" alt="" />
      <div class="navList">
        <div class="item" @click="select(item)" v-for="item in navList" :key="item.id">
          {{ item.title }}
          <div :class="item.id == navIndex ? 'index' : ''"></div>
          <div class="website_list" v-if="item.id == 4">
            <ul class="website_list_item">
              <li
                v-for="item2 in websiteList"
                :key="item2.id"
                @click.stop="select2(item2.name)"
              >
                {{ item2.title }}
              </li>
            </ul>
          </div>
        </div>
        <div class="download_out">
          <div class="download">熊猫云学堂</div>
          <!-- <div class="download">下载APP</div> -->
          <div class="download_content_out">
            <div class="download_inner">
              <div class="download_left">
                <div
                  class="download_tab"
                  :class="item.id == appIndex ? 'active' : ''"
                  @click="selectApp(item)"
                  v-for="item in appList"
                  :key="item.id"
                >
                  {{ item.title }}
                </div>
              </div>
              <div
                v-for="item in appList"
                :key="item.id"
                class="download_right"
                v-show="appIndex == item.id"
              >
                <div class="download_title">
                  <div class="download_logo">
                    <img class="logo_img" :src="item.logo" alt="" />
                    {{ item.title }}
                  </div>
                  <div v-if="item.version" class="download_edition">
                    版本更新：{{ item.version }}
                  </div>
                </div>
                <div class="download_introduc">
                  {{ item.introduce }}
                </div>
                <div class="download_content">
                  <img class="app_edition_img" :src="item.versionImg" alt="" />
                  <img class="app_edition_img" :src="item.versionImg2" alt="" />
                  <div v-if="item.title != '熊猫云学堂'" class="download_edition_img_out">
                    <img class="download_edition_img" :src="item.download" alt="" />
                    <div class="download_edition_title">ios下载</div>
                    <img class="download_edition_img" :src="item.download" alt="" />
                    <div class="download_edition_title">安卓下载</div>
                  </div>
                  <div v-else class="download_edition_img_out download_edition_img_out2">
                    <img class="download_edition_img" :src="item.download" alt="" />
                    <div class="download_edition_title">微信扫一扫</div>
                  </div>
                </div>
                <div class="download_des">开发者信息：湖南米啦科技有限公司</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      item: {},
      navIndex: 1,
      navList: [],
      appIndex: 1,
      appList: [
        {
          id: 1,
          title: "熊猫云学堂",
          name: "panda",
          logo: require("@/assets/pc/logo.png"),
          introduce:
            "熊猫云学堂是您专属的兴趣学习乐园！无论您钟情于书法绘画的雅韵、音乐戏曲的律动，还是热衷养生健身的活力、探索科技生活的奥秘，这里都汇聚了上百门系统化、高品质的兴趣课程。",
          versionImg: require("@/assets/pc/pcHeader/panda1.png"),
          versionImg2: require("@/assets/pc/pcHeader/panda2.png"),
          download: require("@/assets/pc/pcHeader/panda_QR.png"),
        },
        // {
        //   id: 1,
        //   title: "日语GO",
        //   name: "japanese",
        //   logo: require("@/assets/pc/pcHeader/1.png"),
        //   version: "v.1.3.0",
        //   introduce:
        //     "300w注册用户，日活跃用户平均100w，超12000w次Ai测评引擎使用，单词、课程每日更新，最新真题试卷全真模拟。",
        //   versionImg: require("@/assets/pc/pcHeader/2.png"),
        //   versionImg2: require("@/assets/pc/pcHeader/3.png"),
        //   download: require("@/assets/pc/pcHeader/4.png"),
        // },
        // {
        //   id: 2,
        //   title: "德语GO",
        //   name: "german",
        //   logo: require("@/assets/pc/pcHeader/6.png"),
        //   version: "v.1.4.0",
        //   introduce:
        //     "趣味学德语，多方位角度教学，邀请在德学员录制小视频，通过他们的视角了解德国。近千名教师组成导师团，每日更新词汇、视频，留德学生口碑推荐。",
        //   versionImg: require("@/assets/pc/pcHeader/7.png"),
        //   versionImg2: require("@/assets/pc/pcHeader/8.png"),
        //   download: require("@/assets/pc/pcHeader/9.png"),
        // },
        // {
        //   id: 3,
        //   title: "法语GO",
        //   name: "french",
        //   logo: require("@/assets/pc/pcHeader/10.png"),
        //   version: "v.1.0.0",
        //   introduce:
        //     "海量法语资料，多方位角度教学，邀请美国上市教育机构的教师培训师主抓教研，每日更新词汇、视频、更有全真模拟AI测评。",
        //   versionImg: require("@/assets/pc/pcHeader/11.png"),
        //   versionImg2: require("@/assets/pc/pcHeader/12.png"),
        //   download: require("@/assets/pc/pcHeader/13.png"),
        // },
      ],
      websiteList: [
        { id: 1, title: "德语", name: "german" },
        { id: 2, title: "法语", name: "french" },
      ],
    };
  },
  created() {
    if (sessionStorage.item) {
      var item = sessionStorage.item;
      item = JSON.parse(item);
      console.log(item);
      this.navIndex = item.id;
      if (item.name != "home") {
        this.$router.push({ name: item.name });
      }
    }
    this.selectSwitch();
  },
  methods: {
    // 查询网页开关
    async selectSwitch() {
      const { data: result } = await this.$http.post("admin/apply/selectSwitch");
      //state  0 是关闭 1是打开
      if (result.data.state == 1) {
        this.navList = [
          // { id: 1, title: '首页', name: 'home' },
          { id: 1, title: "首页", name: "home" },
          // { id: 6, title: '公司介绍', name: 'examine' },
          { id: 2, title: "公司动态", name: "news" },
          // { id: 3, title: '日语高考', name: 'gaokao' },
          // { id: 4, title: "聚趣网校", name: "product" },
          { id: 5, title: "联系我们", name: "contact" },
        ];
      } else {
        this.navList = [
          { id: 1, title: "公司介绍", name: "home" },
          { id: 2, title: "公司动态", name: "news" },
          // { id: 3, title: '日语高考', name: 'gaokao' },
          // { id: 4, title: "聚趣网校", name: "product" },
          { id: 5, title: "联系我们", name: "contact" },
        ];
      }
    },
    goHome() {
      this.navIndex = 1;
      sessionStorage.navIndex = 1;
      this.$router.push({ name: "home" });
    },
    select(item) {
      if (item.name == "product") {
        window.open("https://german.juquedu.com/school/index.html");
        this.goHome();
        // if (item.title == '日语GO') {
        // 	window.open('https://api.juquedu.com/website/index.html')
        // } else {
        // 	window.open('https://german.juquedu.com/website/index.html')
        // }
        // this.navIndex = 1
        // sessionStorage.navIndex = 1
      } else {
        this.navIndex = item.id;
        sessionStorage.item = JSON.stringify(item);
        // sessionStorage.navIndex = this.navIndex
        this.$router.push({ name: item.name });
      }
    },
    // 跳转网页地址
    select2(value) {
      switch (value) {
        case "french":
          window.open("https://fr.juquedu.com/school/index.html");
          break;
        case "german":
          window.open("https://german.juquedu.com/school/index.html");
          break;
      }
      // this.navIndex = 1
      // sessionStorage.navIndex = 1
      // this.$router.push('/french')
    },
    selectApp(item) {
      this.appIndex = item.id;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 99;
  border-bottom: solid 1px #e8e8e8;
}
.nav {
  display: flex;
  align-items: center;
  height: 64px;
  justify-content: space-between;
  .logo {
    width: 48px;
    height: 48px;
  }
  .logo:hover {
    cursor: pointer;
  }
  .navList {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    height: 100%;
    .item {
      cursor: pointer;
      height: 100%;
      line-height: 64px;
      margin-right: 76px;
      font-weight: bold;
      .index {
        width: 18px;
        margin: auto;
        content: "";
        position: relative;
        bottom: 5px;
        display: block;
        height: 5px;
        text-align: center;
        background-color: #ff293e;
        border-radius: 2.5px;
        animation: fadeInLeft 0.3s ease 0.2s 1 both;
      }
      .website_list {
        display: none;
        width: 100%;
        height: 125px; //8px的距离上部距离
        position: relative;
        .website_list_item {
          width: 100%;
          color: #191919;
          font-size: 16px;
          position: absolute;
          bottom: 0;
          li {
            width: 100%;
            height: 58px;
            line-height: 58px;
            background-color: #ffffff;
            text-align: center;
          }
          li:first-child {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
          }
          li:last-child {
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
          }
          li:hover {
            color: #2532e2;
            background-color: #f5f5f5;
          }
        }
      }
    }
    .item:hover {
      // color: #ecc02c;
      .website_list {
        display: block;
      }
    }
    .item:last-child {
      margin-right: 89px;
    }
    .download_out {
      position: relative;
      .download {
        width: 87px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: #ffffff;
        font-size: 14px;
        background: #ff293e;
        border-radius: 19px;
        cursor: pointer;
      }
      .download_content_out {
        position: absolute;
        right: 0;
        display: none;
        .download_inner {
          width: 584px;
          height: 438px;
          background: #ffffff;
          border-radius: 12px;
          margin-top: 24px;
          display: flex;
          justify-content: space-between;
          .download_left {
            width: 150px;
            height: 438px;
            padding: 20px 16px;
            box-sizing: border-box;
            .download_tab {
              width: 118px;
              height: 48px;
              line-height: 48px;
              text-align: center;
              background: #f8f2ef;
              border-radius: 8px;
              margin-top: 12px;
              font-size: 16px;
              color: #333333;
              cursor: pointer;
            }
            .download_tab:first-child {
              margin-top: 0;
            }
            .active {
              background: #ff293e;
              color: #ffffff;
            }
          }
          .download_right {
            width: 434px;
            height: 438px;
            background: #f8f2ef;
            opacity: 1;
            border-radius: 0px 12px 12px 0px;
            padding: 16px 20px 18px;
            box-sizing: border-box;
            .download_title {
              display: flex;
              align-items: center;
              justify-content: space-between;
              color: #333333;
              font-size: 16px;
              .download_logo {
                display: flex;
                align-items: center;
                justify-content: center;
                .logo_img {
                  width: 40px;
                  height: 40px;
                  margin-right: 10px;
                  border-radius: 8px;
                }
              }
              .download_edition {
                color: #5f6464;
                font-size: 14px;
              }
            }
            .download_introduc {
              height: 56px;
              padding-right: 10px;
              box-sizing: border-box;
              margin: 12px 0 24px;
              color: #333333;
              font-size: 14px;
            }
            .download_content {
              display: flex;
              align-items: center;
              overflow: hidden;
              .app_edition_img {
                width: 136px;
                height: 242px;
                margin-right: 24px;
                border-radius: 8px;
              }
              .app_edition_img:first-child {
                margin-right: 10px;
              }
              .download_edition_img_out {
                height: 242px;
                .download_edition_img {
                  width: 88px;
                  height: 88px;
                }
                .download_edition_title {
                  margin-top: 6px;
                  margin-bottom: 16px;
                  color: #333333;
                  font-size: 12px;
                  text-align: center;
                }
              }
              .download_edition_img_out2 {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              }
            }
            .download_des {
              margin: 16px auto 0;
              color: #333333;
              font-size: 14px;
              text-align: center;
            }
          }
        }
      }
    }
    .download_out:hover {
      .download_content_out {
        display: block;
      }
    }
  }
}
</style>
